class EnergyCostClass {  
    perdite = 1.102;            
    PPE = -0.00263; 
    PD = 0.01489;                 //0.01616;
    DISPbt = -19.2335;            //-13.983;
    trasporto = {               
        prezzo: 0.00889,          //0.00833,
        canone: 20.52,            //20.4,
        prezzoPotenza: 21.24      //20.88
    };
    oneri = {
        prezzo: 0,                 // 0.024393,
        canone: 0                  // 72.8496           //- only for not resident
    };
}
var EnergyCosts = new EnergyCostClass();

//- ---

/*class GasCostClass {  

}
//var GasCosts = new GasCostClass();*/

//- ---

export { EnergyCosts }